import { createTheme } from '@mui/material/styles';

const defaultTheme = {
  palette: {
    primary: { main: '#ffcc01', light: '#ffd21f' },
    secondary: { main: '#9c27b0', light: '#b434c9' },
    danger: { main: '#FC0F12', light: '#ff4042' },
    random: {
      1: { main: '#E74C3C', light: '#ec7669' },
      2: { main: '#9B59B6', light: '#b27cc5' },
      3: { main: '#5499C7', light: '#78afd3' },
      4: { main: '#45B39D', light: '#68c4b2' },
      5: { main: '#F4D03F', light: '#f7db6e' },
      6: { main: '#F5B041', light: '#f8c572' },
      7: { main: '#cb77ed', light: '#e8d8ee' },
      8: { main: '#6734eb', light: '#8961ef' },
    },
    porHacer: { main: '#F48847', light: '#ffa169' },
    alta: { main: '#FFC84B', light: '#ffd575' },
    pago: { main: '#67a813', light: '#78bf1d' },
    ventas: { main: '#1a46bd', light: '#2454d6' },
    enProceso: { main: '#A6C34C', light: '#b4cf63' },
    terminado: { main: '#4EC04E', light: '#66d166' },
    practica: { main: '#4767c9', light: '#5d7dde' },
    notifications: { main: '#c221c2', light: '#d92ed9' },
    authorizations: { main: '#9947c9', light: '#b25de3' },
    enAgenda: { main: '#FD534C', light: '#fc7772' },
    excel: { main: '#1F6E43', light: '#33915e' },
    randomColor1: { main: '#E74C3C', light: '#ec7669' },
    randomColor2: { main: '#9B59B6', light: '#b27cc5' },
    randomColor3: { main: '#5499C7', light: '#78afd3' },
    randomColor4: { main: '#45B39D', light: '#68c4b2' },
    randomColor5: { main: '#F4D03F', light: '#f7db6e' },
    randomColor6: { main: '#F5B041', light: '#f8c572' },
    randomColor7: { main: '#cb77ed', light: '#e8d8ee' },
    randomColor8: { main: '#6734eb', light: '#8961ef' },
    randomColor9: { main: '#D96B6B', light: '#E58989' },
    randomColor10: { main: '#E3A848', light: '#E8BF75' },
    randomColor11: { main: '#78B0A6', light: '#92C2BA' },

    white: { main: '#ffffff' },
    black: { main: '#484848', dark: '#333333' },
    gray: { main: '#dfdfdf', light: '#ebebeb' },
    default: { main: '#ffffff' },
  },
  icons: {
    main: {
      size: 14,
    },
  },
  sizes: {
    sm: {
      t1: 12,
      t2: 14,
      t3: 16,
    },
    md: {
      t1: 18,
      t2: 20,
      t3: 24,
    },
    lg: {
      t1: 32,
    },
  },
  typography: {
    fontFamily: ['Roboto', 'sans-serif'].join(','),
  },
};

const theme = createTheme(defaultTheme);

interface PaletteItem {
  main: string;
  light: string;
}
//
export interface ITheme {
  palette: {
    primary: PaletteItem;
    secondary: PaletteItem;
    danger: PaletteItem;
    random: Object;
    porHacer: PaletteItem;
    alta: PaletteItem;
    pago: PaletteItem;
    ventas: PaletteItem;
    enProceso: PaletteItem;
    terminado: PaletteItem;
    practica: PaletteItem;
    notifications: PaletteItem;
    authorizations: PaletteItem;
    enAgenda: PaletteItem;
    excel: PaletteItem;
    randomColor1: PaletteItem;
    randomColor2: PaletteItem;
    randomColor3: PaletteItem;
    randomColor4: PaletteItem;
    randomColor5: PaletteItem;
    randomColor6: PaletteItem;
    randomColor7: PaletteItem;
    randomColor8: PaletteItem;
    randomColor9: PaletteItem;
    randomColor10: PaletteItem;
    randomColor11: PaletteItem;
    white: PaletteItem;
    black: PaletteItem;
    gray: PaletteItem;
    default: PaletteItem;
  };
  icons: Object;
  sizes: {
    sm: {
      t1: number;
      t2: number;
      t3: number;
    };
    md: {
      t1: number;
      t2: number;
      t3: number;
    };
    lg: {
      t1: number;
    };
  };
  typography: Object;
}

export default theme;
